var React = require('react');

function IconCircleTick (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z","fill":"currentColor","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M25.123 15.7502C25.5072 15.3657 26.1304 15.3655 26.5149 15.7497C26.8993 16.1339 26.8996 16.7571 26.5154 17.1415L18.6449 25.0177C18.2606 25.4022 17.6373 25.4023 17.2529 25.0179L13.3134 21.0784C12.9291 20.6941 12.9291 20.071 13.3134 19.6866C13.6977 19.3023 14.3209 19.3023 14.7052 19.6866L17.9485 22.9299L25.123 15.7502Z","fill":"white","key":1})]);
}

IconCircleTick.defaultProps = {"viewBox":"0 0 40 40","fill":"currentColor"};

module.exports = IconCircleTick;

IconCircleTick.default = IconCircleTick;
